import { T } from 'src/shared/helpers';

export const STANDALONE_SITE_HOST = 'customhub.app';
const STANDALONE_SITE_SUBDOMAIN_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const getStandaloneSiteSubdomain = (domain?: string | null) => {
    const host = domain
        ?.trim()
        .replace(/^https?:\/\//i, '')
        .replace(/\/.*$/, '')
        .replace(/\.$/, '');

    if (!host) return undefined;

    const portalSuffix = `.${STANDALONE_SITE_HOST}`;
    const normalizedHost = host.toLowerCase();
    return normalizedHost.endsWith(portalSuffix) ? normalizedHost.slice(0, -portalSuffix.length) : normalizedHost;
};

export const validateStandaloneSiteSubdomain = (domain?: string | null) => {
    const subdomain = getStandaloneSiteSubdomain(domain);
    return !subdomain || !STANDALONE_SITE_SUBDOMAIN_REGEX.test(subdomain);
};

export const getStandaloneSiteSubdomainValidationMessage = (domain?: string | null) => {
    const subdomain = getStandaloneSiteSubdomain(domain);
    if (!subdomain) return T._('Domain is required.', 'Admin');
    return T._('Subdomain must use only letters, numbers, and hyphens. It cannot start or end with a hyphen.', 'Admin');
};

export const getStandaloneSiteDisplayDomain = (domain?: string | null) => {
    const subdomain = getStandaloneSiteSubdomain(domain);
    return subdomain ? `${subdomain}.${STANDALONE_SITE_HOST}` : undefined;
};

export const getStandaloneSitePublicUrl = (domain?: string | null) => {
    const displayDomain = getStandaloneSiteDisplayDomain(domain);
    return displayDomain ? `https://${displayDomain}` : undefined;
};
